import cx from 'classnames';
import { Icon, IconName } from '@ets/design-system';
import styles from './ViewAnnotationCard.module.scss';
import { useIntl } from 'react-intl';

type AnnotationType = {
  type: PDF.Annotation['subtype'];
  notification?: boolean;
};

const AnnotationType = ({ type, notification }: AnnotationType) => {
  const intl = useIntl();
  let icon: IconName | null = null;
  let labelId: string | null = null;

  switch (type) {
    case 'Note':
      icon = 'comment';
      labelId = 'global.comment';
      break;
    case 'Highlight':
      icon = 'highlighter-line';
      labelId = 'HIGHLIGHTED_TEXT';
      break;
    case 'Underline':
      icon = 'underline';
      labelId = 'UNDERLINED_TEXT';
      break;
    case 'StrikeOut':
      icon = 'strikethrough';
      labelId = 'STRIKETHROUGH_TEXT';
      break;
    case 'Line':
    case 'Square':
    case 'Circle':
    case 'Polygon':
    case 'PolyLine':
      icon = 'shapes';
      labelId = 'SHAPE';
      break;
    case 'FreeText':
      icon = 'message-text';
      labelId = 'TEXT_BOX';
      break;
    case 'Ink':
      icon = 'scribble';
      labelId = 'FREEHAND';
      break;
  }

  if (icon && labelId) {
    return (
      <div
        className={cx({
          [styles.annotationType]: true,
          [styles.notification]: notification,
        })}
        data-testid={`annotation-type-${type.toLowerCase()}`}
      >
        <Icon size="2" icon={icon} testId={icon} />
        <span>{intl.formatMessage({ id: labelId })}</span>
      </div>
    );
  }
  return null;
};

export default AnnotationType;
